import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent } from "../../utils";
import { useAuth } from "../../hooks/useAuth";
import {
    selectMultipleApplicationData,
    selectMultipleApplicationStatus,
    selectMultipleApplicationError,
    initializeAsync,
} from "./multipleApplicationSlice";
import { Box, Button, Card, CardContent, Container, Divider, Typography } from "@mui/material";
import { InlineText } from "../../components/InlineText";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import { useNavigate } from "react-router-dom";
import { PropertyDetailsCard } from "../../components/PropertyDetailsCard";

// Add custom imports here

const MultipleApplication = () => {
    const data = useSelector(selectMultipleApplicationData);
    const status = useSelector(selectMultipleApplicationStatus);
    const error = useSelector(selectMultipleApplicationError);
    const dispatch = useDispatch();
    const { getUserDetailsNotAsync, setUserDetailsNotAsync } = useAuth();
    let userDetails = getUserDetailsNotAsync();
    const navigate = useNavigate();

    // Add Variables

    useEffect(() => {
        if (status === "idle") {
            dispatch(initializeAsync());
        }
    }, [status, dispatch]);

    const getApplications = () => {
        return userDetails.applicants;
    };

    const handleContinue = (applicant) => {
        userDetails.applicant = applicant;
        userDetails["listingId"] = applicant.application.applicationListingId;
        setUserDetailsNotAsync(userDetails);

        if (userDetails?.applicant?.status === "Submitted" ||
            userDetails?.applicant?.status === "Processing" ||
            userDetails?.applicant?.status === "Cancelled" ||
            userDetails?.applicant?.status === "Declined" ||
            userDetails?.applicant?.status === "Approved") {
            navigate("/application-completion", {
                replace: true,
            });
        } else {
            navigate("/", { replace: false });
        }
    };

    let body = (
        <>
            {status === "initalLoading" ? (
                <></>
            ) : (
                <>
                    <Container className="MultipleApplication">
                        <Typography variant="h1" component="h1">
                            Multiple Applications Found!
                        </Typography>
                        <Typography variant="h6" component="h6" sx={{ textAlign: "center" }}>
                            Select one of the applications to proceed.
                        </Typography>
                        <Grid sx={{ width: "100%", justifyContent: "center" }} spacing={3} container>
                            {getApplications()?.length > 0 && (
                                <>
                                    {getApplications().map((applicant) => (
                                        <Grid item xs={12} lg={4}>
                                            <Card sx={{ width: "100%" }}>
                                                <CardContent sx={{ width: "100%" }}>
                                                    <Box
                                                        sx={{
                                                            justifyContent: "start",
                                                            alignItems: "center",
                                                            display: "flex",
                                                        }}
                                                    >
                                                        <Box>
                                                            <Box
                                                                sx={{
                                                                    p: "8px",
                                                                    borderRadius: "5px",
                                                                    border: "solid 1px #ececec",
                                                                    color: "#02afd4",
                                                                    height: "50px",
                                                                    marginRight: "10px",
                                                                }}
                                                            >
                                                                <AcUnitIcon sx={{ fontSize: "2rem" }}></AcUnitIcon>
                                                            </Box>
                                                        </Box>
                                                        <Box>
                                                            <Typography variant="cardHeading" component="div">
                                                                {applicant.application?.name}
                                                            </Typography>
                                                            <Typography
                                                                variant="h6"
                                                                component="div"
                                                                color="text.secondary"
                                                            >
                                                                {applicant.primaryApplicant
                                                                    ? "As primary applicant"
                                                                    : "As co-applicant"}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            border: "1px solid #ececec",
                                                            marginTop: "10px",
                                                            padding: "8px",
                                                            borderRadius: "5px",
                                                            minHeight: "100px",
                                                        }}
                                                    >
                                                        <PropertyDetailsCard
                                                            item={applicant.application}
                                                        ></PropertyDetailsCard>
                                                    </Box>

                                                    <Divider sx={{ my: ".8rem" }}></Divider>
                                                    <Button
                                                        onClick={() => handleContinue(applicant)}
                                                        color="primary"
                                                        type="submit"
                                                        fullWidth
                                                        variant="contained"
                                                        sx={{ height: "45px" }}
                                                    >
                                                        Continue this application
                                                    </Button>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    ))}
                                </>
                            )}
                        </Grid>
                    </Container>
                </>
            )}
        </>
    );

    return getPageContent(body, status, error);
};

export { MultipleApplication };
